import type { StockSummaryDTO } from "@/modules/inventory/domain/contracts";
import { formatPriceLak } from "@/shared/lib/format-price";
import { Banknote, Coins, Package } from "lucide-react";

type Props = {
  data: StockSummaryDTO | undefined;
  isLoading: boolean;
};

export function StockSummaryCards({ data, isLoading }: Props) {
  const qty =
    data != null
      ? data.totalQuantity.toLocaleString("en-US", {
          maximumFractionDigits: 0,
        })
      : "—";

  const cost =
    data != null
      ? formatPriceLak(data.totalCostValue, { suffix: true })
      : "—";

  const retail =
    data != null
      ? formatPriceLak(data.totalRetailValue, { suffix: true })
      : "—";

  return (
    <div className="mb-4 grid gap-4 sm:grid-cols-3">
      <div className="rounded-xl border bg-card p-5">
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-lg bg-muted">
            <Package className="size-5 text-muted-foreground" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ຈຳນວນຊິ້ນໃນສະຕ໋ອກ</p>
            <p className="font-semibold text-xl">
              {isLoading ? "—" : qty}
            </p>
          </div>
        </div>
        <p className="mt-2 text-muted-foreground text-xs">
          ຜົນລວມ quantity ຕາມ filter
        </p>
      </div>

      <div className="rounded-xl border bg-card p-5">
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-lg bg-amber-500/10">
            <Coins className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ມູນຄ່າຕົ້ນທຶນ</p>
            <p className="font-semibold text-xl">
              {isLoading ? "—" : cost}
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-xl border bg-card p-5">
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-lg bg-emerald-500/10">
            <Banknote className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ມູນຄ່າລາຄາຂາຍ</p>
            <p className="font-semibold text-xl">
              {isLoading ? "—" : retail}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
